/* Frostly — Home / behaviors (vanilla, no deps)
   commercial-animation: counters RAF 1x · carousel auto-advance · sticky ATC · IO reveal · multi-CTA pulse
   Floor: reduced-motion respected · no infinite loops · post-LCP */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* IO reveal fallback (browsers sem animation-timeline) */
  if (!CSS.supports('animation-timeline: view()')) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    document.querySelectorAll('.fh-io-reveal').forEach(function (el) { io.observe(el); });
  }

  /* Count-up (once, tabular-nums) */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fh-count')) || 0;
    var suffix = el.getAttribute('data-fh-suffix') || '';
    var dec = (el.getAttribute('data-fh-dec') === '1');
    var stat = el.closest ? el.closest('.fh-stat') : null;
    if (stat) { var fill = stat.querySelector('.fh-stat__fill'); if (fill) { var fp = fill.getAttribute('data-fh-fill'); if (fp) { fill.style.width = fp + '%'; } } }
    if (RM) { el.textContent = (dec ? target.toFixed(1) : Math.round(target).toLocaleString()) + suffix; return; }
    var start = null, dur = 1500;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3); /* ease-out */
      var v = target * e;
      el.textContent = (dec ? v.toFixed(1) : Math.round(v).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-fh-count]').forEach(function (el) { cio.observe(el); });

  /* Carousel auto-advance 4.5s (pause on hover/focus/touch; off em reduced-motion) */
  document.querySelectorAll('[data-fh-carousel]').forEach(function (track) {
    if (RM) return;
    var timer, paused = false;
    function next() {
      if (paused) return;
      var w = track.querySelector('.fh-carousel__slide');
      if (!w) return;
      var step = w.getBoundingClientRect().width + 16;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    }
    function start() { timer = setInterval(next, 4500); }
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }, { passive: true }); });
    start();
  });

  /* Carousel controls (dots + arrows) */
  document.querySelectorAll('[data-fh-carousel]').forEach(function (track) {
    var root = track.closest('.fh-carousel'); if (!root) return;
    var dotsWrap = root.querySelector('[data-fh-dots]');
    var prev = root.querySelector('.fh-carousel__arrow--prev');
    var next = root.querySelector('.fh-carousel__arrow--next');
    if (!dotsWrap && !prev && !next) return;
    function step() { var s = track.querySelector('.fh-carousel__slide'); return s ? s.getBoundingClientRect().width + 16 : track.clientWidth; }
    var slides = track.querySelectorAll('.fh-carousel__slide');
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'fh-carousel__dot'; d.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
        d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
        dotsWrap.appendChild(d); dots.push(d);
      });
    }
    function sync() { var idx = Math.round(track.scrollLeft / step()); dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    sync();
  });

  /* Sticky ATC: revela só quando o CTA principal (hero na home / BUY NOW na PDP) sai de viewport */
  var bar = document.querySelector('[data-fh-stickybar]');
  var anchor = document.querySelector('.fh-hero__cta') || document.getElementById('frostly-buy') || document.querySelector('.fh-buybox__atc');
  if (bar && anchor) {
    var sio = new IntersectionObserver(function (es) {
      var e = es[0];
      /* mostra só quando o botão principal já passou PARA CIMA do ecrã (não quando ainda está por baixo) */
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    sio.observe(anchor);
  }

  /* Multi-CTA pulse 1x on view */
  var pio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-seen'); pio.unobserve(e.target); } });
  }, { threshold: 0.6 });
  document.querySelectorAll('.fh-cta-pulse').forEach(function (el) { pio.observe(el); });
})();
